export function getPONum(text: string): string {
    return text === null || text.trim() === "" ? "Enter PO#" : text.trim();
}
